module.exports = __webpack_public_path__ + "static/media/profile-dropdown.451d7dde.svg";